import React, { useState } from "react";
import { useParams } from "react-router-dom";
import Filter from "../components/masterplan/filter/filter";
import MasterPlaneInner from "../components/masterplan/masterplane";
// import Master_plan from "../components/masterplan/master-plan/MasterPlane";
import BottomNav from "../components/navbar/bottomnav/bottomNav";
import ProgressModal from "../components/modal/ProgressModal/ProgressModal";
import Spin from "../components/modal/spin360/spin";
import Classification from "../components/masterplan/Classification/Classification";
function MasterPage({
  lang = "en",
  isOverlayHidden = false,
  filterSelection,
  setFilterSelection,
}) {
  // console.log("MasterPage received lang:", lang);
 const { projectSlug, zoneId } = useParams();
  const zoneIdNumber = zoneId ? parseInt(zoneId, 10) : null;
  const [progressVilla, setProgressVilla] = useState(null);
  const [spinVilla, setSpinVilla] = useState(null);

  if (!zoneIdNumber || isNaN(zoneIdNumber)) {
    return (
      <div className="text-center mt-5">لا يوجد معرف منطقة صالح في الرابط!</div>
    );
  }

  return (
    <div
      className={`master-plan-with-filter p-0 ${
        lang === "ar" ? "rtl" : "ltr"
      }`}
    >
      <Filter lang={lang} />

      {/* <BottomNav
        setProgressVilla={setProgressVilla}
        setSpinVilla={setSpinVilla}
      /> */}

      <MasterPlaneInner
      projectSlug={projectSlug}
        filterSelection={filterSelection}
        isOverlayHidden={isOverlayHidden}
        lang={lang}
        setProgressVilla={setProgressVilla}
        setSpinVilla={setSpinVilla}
      />

      <ProgressModal
        isOpen={!!progressVilla}
        onClose={() => setProgressVilla(null)}
        units={progressVilla ? [progressVilla] : []}
      />

      <Spin
        isOpen={!!spinVilla}
        onClose={() => setSpinVilla(null)}
        villa={spinVilla}
      />


        <Classification />
{/* 
        <Master_plan   filterSelection={filterSelection}
        isOverlayHidden={isOverlayHidden}
        lang={lang}
        setProgressVilla={setProgressVilla}
        setSpinVilla={setSpinVilla} /> */}
    </div>
  );
}

export default MasterPage;
